import { useState, useEffect } from "react";
import { supabase } from "../supabase";

const C = {
  bg:"#0e0e0e", surface:"#181818", surface2:"#202020",
  border:"#2a2a2a", muted:"#666", orange:"#FF5F1F", magenta:"#E8197D",
  gold:"#F5A623", green:"#4ade80", white:"#fff", red:"#f87171", blue:"#60a5fa",
};

const card  = (x={}) => ({ background:C.surface, borderRadius:10, padding:16, border:`0.5px solid ${C.border}`, ...x });
const btn   = (v="primary",x={}) => ({ padding:"8px 16px", borderRadius:8, fontSize:13, fontWeight:500, cursor:"pointer", border:"none", boxSizing:"border-box", ...(v==="primary"?{background:`linear-gradient(135deg,${C.orange},${C.magenta})`,color:C.white}:{}), ...(v==="ghost"?{background:"none",border:`0.5px solid ${C.border}`,color:C.muted}:{}), ...(v==="danger"?{background:"#3d1515",color:C.red,border:`0.5px solid #f8717133`}:{}), ...x });
const inp   = (x={}) => ({ background:C.surface2, border:`0.5px solid ${C.border}`, borderRadius:8, padding:"9px 12px", color:C.white, fontSize:13, outline:"none", width:"100%", boxSizing:"border-box", ...x });
const lbl   = t => <div style={{fontSize:11,color:C.muted,marginBottom:4,textTransform:"uppercase",letterSpacing:0.5}}>{t}</div>;
const gradBar = <div style={{height:2,background:`linear-gradient(90deg,${C.orange},${C.magenta},${C.gold})`,borderRadius:1,marginBottom:24}}/>;

const roleCfg = {
  danser:   { label:"Danser",   color:"#E8197D" },
  vokalist: { label:"Vokalist", color:"#a78bfa" },
  tm:       { label:"TM",       color:"#F5A623" },
  akrobat:  { label:"Akrobat",  color:"#FF5F1F" },
  musiker:  { label:"Musiker",  color:"#60a5fa" },
  tekniker: { label:"Tekniker", color:"#94a3b8" },
};

function RoleBadge({ role }) {
  const cfg = roleCfg[role] || { label:role, color:C.muted };
  return (
    <span style={{fontSize:11,padding:"2px 8px",borderRadius:20,background:`${cfg.color}22`,color:cfg.color,border:`0.5px solid ${cfg.color}44`,marginRight:4}}>
      {cfg.label}
    </span>
  );
}

function Toast({ msg, ok }) {
  if(!msg) return null;
  return (
    <div style={{position:"fixed",bottom:24,left:"50%",transform:"translateX(-50%)",background:ok===false?"#3d1515":"#14532d",color:ok===false?C.red:C.green,padding:"10px 20px",borderRadius:8,fontSize:13,zIndex:999,border:`0.5px solid ${ok===false?"#f8717133":"#4ade8033"}`}}>
      {msg}
    </div>
  );
}

function useToast() {
  const [toast,setToast] = useState({msg:"",ok:true});
  const showToast = (msg,ok=true) => { setToast({msg,ok}); setTimeout(()=>setToast({msg:"",ok:true}),2500); };
  return [toast,showToast];
}

function RepertoireForm({ initial, onSave, onCancel, isMobile }) {
  const [title,        setTitle]       = useState(initial?.title||"");
  const [duration,     setDuration]    = useState(initial?.duration||"");
  const [roles]        = useState(initial?.roles||[]);
  const [notes,        setNotes]       = useState(initial?.notes||"");
  const [type,         setType]        = useState(initial?.type||"single");
  const [medleyTracks, setMedleyTracks]= useState(initial?.medley_tracks||"");
  const [links,        setLinks]       = useState(initial?.links||{instrumental:"",klikktrack:"",choir:"",acapella:"",outro:"",visuals:"",tc:"",koreografi:"",showzip:""});
  const [costume,      setCostume]     = useState(initial?.costume||"");
  const [hairMakeup,   setHairMakeup]  = useState(initial?.hair_makeup||"");
  const [repNotes,     setRepNotes]    = useState(initial?.rep_notes||"");
  const setLink = (k,v) => setLinks(prev=>({...prev,[k]:v}));


  const save = () => {
    if(!title.trim()) return;
    onSave({ title:title.trim(), duration:duration.trim(), roles, notes:notes.trim(), type, medley_tracks:type==="medley"?medleyTracks.trim():"", links, costume:costume.trim(), hair_makeup:hairMakeup.trim(), rep_notes:repNotes.trim() });
  };

  return (
    <div style={card({marginBottom:16,border:`0.5px solid ${C.orange}44`})}>
      <div style={{display:"grid",gridTemplateColumns:isMobile?"1fr":"1fr 1fr",gap:12,marginBottom:12}}>
        <div>
          {lbl("Tittel *")}
          <input style={inp({})} value={title} onChange={e=>setTitle(e.target.value)} placeholder="f.eks. Proud Mary" onKeyDown={e=>e.key==="Enter"&&save()}/>
        </div>
        <div>
          {lbl("Varighet")}
          <input style={inp({})} value={duration} onChange={e=>setDuration(e.target.value)} placeholder="f.eks. 4:30"/>
        </div>
      </div>
      <div style={{marginBottom:12}}>
        {lbl("Type")}
        <div style={{display:"flex",gap:8,marginTop:4}}>
          {[{val:"single",label:"Enkeltlåt",color:C.blue},{val:"medley",label:"Medley",color:C.gold}].map(({val,label,color})=>(
            <div key={val} onClick={()=>setType(val)} style={{padding:"6px 16px",borderRadius:20,fontSize:12,cursor:"pointer",fontWeight:500,
              background:type===val?`${color}33`:"transparent",
              color:type===val?color:C.muted,
              border:`0.5px solid ${type===val?color:C.border}`}}>
              {label}
            </div>
          ))}
        </div>
      </div>
      {type==="medley"&&<div style={{marginBottom:12}}>
        {lbl("Låter i medleyen")}
        <textarea style={inp({minHeight:80,resize:"vertical"})} value={medleyTracks} onChange={e=>setMedleyTracks(e.target.value)} placeholder={"1. Proud Mary\n2. It's a Man's World\n3. Bitchmedley"}/>
      </div>}
      <div style={{marginBottom:12}}>
        {lbl("Filer og lenker")}
        <div style={{display:"flex",flexDirection:"column",gap:8,marginTop:4}}>
          {[
            {key:"instrumental", label:"Instrumental"},
            {key:"klikktrack",   label:"Klikktrack"},
            {key:"choir",        label:"Choir-track"},
            {key:"acapella",     label:"Acapella"},
            {key:"outro",        label:"Outro"},
            {key:"visuals",      label:"Visuals"},
            {key:"tc",           label:"TC fil (lys)"},
            {key:"koreografi",   label:"Koreografi (video)"},
            {key:"showzip",      label:"Show ZIP"},
          ].map(({key,label})=>(
            <div key={key} style={{display:"grid",gridTemplateColumns:isMobile?"1fr":"140px 1fr",gap:isMobile?4:8,alignItems:isMobile?"flex-start":"center"}}>
              <div style={{fontSize:12,color:C.muted}}>{label}</div>
              <input style={inp({fontSize:12})} value={links[key]||""} onChange={e=>setLink(key,e.target.value)} placeholder="https://..."/>
            </div>
          ))}
        </div>
      </div>
      <div style={{marginBottom:12}}>
        {lbl("Notater")}
        <textarea style={inp({minHeight:72,resize:"vertical"})} value={notes} onChange={e=>setNotes(e.target.value)} placeholder="Koreograf, instruksjoner..."/>
      </div>
      <div style={{marginBottom:12}}>
        {lbl("Standard kostyme")}
        <textarea style={inp({minHeight:60,resize:"vertical"})} value={costume} onChange={e=>setCostume(e.target.value)} placeholder="Beskriv kostymet for dette nummeret..."/>
      </div>
      <div style={{marginBottom:12}}>
        {lbl("Standard hår og sminke")}
        <textarea style={inp({minHeight:60,resize:"vertical"})} value={hairMakeup} onChange={e=>setHairMakeup(e.target.value)} placeholder="Hårfrisyre, sminke, instruksjoner..."/>
      </div>
      <div style={{marginBottom:16}}>
        {lbl("Standard notater (show-program)")}
        <textarea style={inp({minHeight:60,resize:"vertical"})} value={repNotes} onChange={e=>setRepNotes(e.target.value)} placeholder="Notater som hentes automatisk til show-programmet..."/>
      </div>
      <div style={{display:"flex",gap:8}}>
        <button style={btn("ghost",{flex:1})} onClick={onCancel}>Avbryt</button>
        <button style={btn("primary",{flex:1})} onClick={save}>Lagre</button>
      </div>
    </div>
  );
}

// ── RepertoirePicker – brukes inne i event-moduler ──
export function RepertoirePicker({ onSelect, onClose }) {
  const [items, setItems] = useState([]);
  const [search, setSearch] = useState("");

  useEffect(()=>{
    supabase.from("repertoire").select("*").order("title").then(({data})=>setItems(data||[]));
  },[]);

  const filtered = items.filter(i=>i.title.toLowerCase().includes(search.toLowerCase()));

  return (
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.75)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:300,padding:16}}>
      <div style={{background:C.surface,borderRadius:12,padding:24,width:"100%",maxWidth:480,border:`0.5px solid ${C.border}`,maxHeight:"80vh",display:"flex",flexDirection:"column"}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16}}>
          <div style={{fontSize:16,fontWeight:500}}>Velg fra repertoire</div>
          <button onClick={onClose} style={{background:"none",border:"none",color:C.muted,fontSize:22,cursor:"pointer"}}>×</button>
        </div>
        <input style={inp({marginBottom:12})} placeholder="Søk..." value={search} onChange={e=>setSearch(e.target.value)} autoFocus/>
        <div style={{overflowY:"auto",flex:1}}>
          {filtered.length===0&&<div style={{color:C.muted,fontSize:13,textAlign:"center",padding:20}}>Ingen treff</div>}
          {filtered.map(item=>(
            <div key={item.id} onClick={()=>{onSelect(item);onClose();}}
              style={{padding:"12px",borderRadius:8,cursor:"pointer",marginBottom:6,background:C.surface2,border:`0.5px solid ${C.border}`}}
              onMouseEnter={e=>e.currentTarget.style.borderColor=C.orange}
              onMouseLeave={e=>e.currentTarget.style.borderColor=C.border}>
              <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:4}}>
                <span style={{fontSize:13,fontWeight:500,color:C.white}}>{item.title}</span>
                {item.duration&&<span style={{fontSize:11,color:C.muted}}>{item.duration}</span>}
              </div>
              <div>{(item.roles||[]).map(r=><RoleBadge key={r} role={r}/>)}</div>
              {item.notes&&<div style={{fontSize:11,color:C.muted,marginTop:4}}>{item.notes}</div>}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

// ── RepertoirePage – admin-siden ──
export function RepertoirePage({ isMobile }) {
  const [items,      setItems]     = useState([]);
  const [loading,    setLoading]   = useState(true);
  const [showForm,   setShowForm]  = useState(false);
  const [editing,    setEditing]   = useState(null);
  const [search,     setSearch]    = useState("");
  const [typeFilter, setTypeFilter]= useState("all");
  const [expandedId, setExpandedId]= useState(null);
  const [toast,      showToast]    = useToast();

  useEffect(()=>{
    supabase.from("repertoire").select("*").order("title").then(({data})=>{ setItems(data||[]); setLoading(false); });
  },[]);

  const save = async (data) => {
    if(editing) {
      const {error} = await supabase.from("repertoire").update({...data,updated_at:new Date().toISOString()}).eq("id",editing.id);
      if(error){ showToast("Kunne ikke lagre.",false); return; }
      setItems(prev=>prev.map(i=>i.id===editing.id?{...i,...data}:i).sort((a,b)=>a.title.localeCompare(b.title)));
      showToast("Lagret!");
    } else {
      const {data:inserted,error} = await supabase.from("repertoire").insert(data).select().single();
      if(error){ showToast("Kunne ikke lagre.",false); return; }
      setItems(prev=>[...prev,inserted].sort((a,b)=>a.title.localeCompare(b.title)));
      showToast("Lagt til!");
    }
    setShowForm(false);
    setEditing(null);
  };

  const remove = async (id) => {
    if(!window.confirm("Slette denne låten fra repertoaret?")) return;
    const {error} = await supabase.from("repertoire").delete().eq("id",id);
    if(error){ showToast("Kunne ikke slette.",false); return; }
    setItems(prev=>prev.filter(i=>i.id!==id));
    showToast("Slettet.");
  };

  const filtered = items
    .filter(i=>i.title.toLowerCase().includes(search.toLowerCase()))
    .filter(i=>typeFilter==="all"||i.type===typeFilter)
    .sort((a,b)=>a.title.localeCompare(b.title,"nb"));

  const singles = filtered.filter(i=>i.type==="single");
  const medleys = filtered.filter(i=>i.type==="medley");

  return (
    <div style={{paddingBottom:isMobile?80:0,maxWidth:720}}>
      <Toast msg={toast.msg} ok={toast.ok}/>
      {gradBar}
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:20}}>
        <div style={{fontSize:20,fontWeight:500}}>Repertoire</div>
        <button style={btn("primary")} onClick={()=>{setShowForm(true);setEditing(null);}}>+ Legg til</button>
      </div>

      {(showForm&&!editing)&&<RepertoireForm onSave={save} onCancel={()=>setShowForm(false)} isMobile={isMobile}/>}

      <div style={{display:"flex",gap:8,marginBottom:12,flexWrap:"wrap"}}>
        <input style={{...inp({}),flex:1,minWidth:160}} placeholder="Søk i repertoar..." value={search} onChange={e=>setSearch(e.target.value)}/>
        {["all","single","medley"].map(f=>(
          <button key={f} onClick={()=>setTypeFilter(f)} style={{padding:"6px 14px",borderRadius:20,fontSize:12,cursor:"pointer",border:`0.5px solid ${typeFilter===f?C.orange:C.border}`,background:typeFilter===f?"#FF5F1F22":"transparent",color:typeFilter===f?C.orange:C.muted,whiteSpace:"nowrap"}}>
            {f==="all"?"Alle":f==="single"?"Enkeltlåter":"Medleys"}
          </button>
        ))}
      </div>
      <div style={{fontSize:11,color:C.muted,marginBottom:16}}>{filtered.length} {filtered.length===1?"nummer":"numre"}</div>

      {loading&&<div style={{color:C.muted,textAlign:"center",padding:40}}>Laster...</div>}

      {!loading&&filtered.length===0&&(
        <div style={card({textAlign:"center",padding:40})}>
          <div style={{fontSize:14,color:C.muted}}>{search?"Ingen treff":"Ingen låter lagt til ennå"}</div>
        </div>
      )}

      {singles.length>0&&<div style={{fontSize:11,color:C.muted,textTransform:"uppercase",letterSpacing:0.8,marginBottom:8,fontWeight:600}}>Enkeltlåter ({singles.length})</div>}
      {singles.map(item=>{
        const expanded = expandedId === item.id;
        const hasLinks = item.links && Object.values(item.links).some(v=>v);
        const ALL_LINKS = [
          {key:"instrumental", label:"Instrumental"},
          {key:"klikktrack",   label:"Klikktrack"},
          {key:"choir",        label:"Choir-track"},
          {key:"acapella",     label:"Acapella"},
          {key:"outro",        label:"Outro"},
          {key:"visuals",      label:"Visuals"},
          {key:"tc",           label:"TC fil (lys)"},
          {key:"koreografi",   label:"Koreografi (video)"},
          {key:"showzip",      label:"Show ZIP"},
        ];
        
        return (
          <div key={item.id} style={{marginBottom:8}}>
            {editing?.id===item.id
              ? <RepertoireForm initial={item} onSave={save} onCancel={()=>setEditing(null)} isMobile={isMobile}/>
              : <div style={card({padding:0,overflow:"hidden"})}>
                  {/* Kompakt header – alltid synlig */}
                  <div onClick={()=>setExpandedId(expanded?null:item.id)} style={{display:"flex",alignItems:"center",gap:12,padding:"12px 14px",cursor:"pointer"}}
                    onMouseEnter={e=>e.currentTarget.style.background=C.surface2}
                    onMouseLeave={e=>e.currentTarget.style.background="transparent"}>
                    <div style={{flex:1,minWidth:0}}>
                      <div style={{display:"flex",alignItems:"center",gap:8,flexWrap:"wrap"}}>
                        <div style={{fontSize:14,fontWeight:500}}>{item.title}</div>
                        {item.duration&&<div style={{fontSize:12,color:C.muted}}>{item.duration}</div>}
                        <span style={{fontSize:11,padding:"2px 8px",borderRadius:20,background:`${C.blue}22`,color:C.blue,border:`0.5px solid ${C.blue}44`}}>
                          Enkeltlåt
                        </span>
                        {hasLinks&&<span style={{fontSize:11,color:C.muted}}>🔗 {Object.values(item.links).filter(v=>v).length} filer</span>}
                      </div>
                    </div>
                    <div style={{fontSize:10,color:C.muted,transition:"transform 0.2s",transform:expanded?"rotate(180deg)":"rotate(0deg)",flexShrink:0}}>▾</div>
                  </div>

                  {/* Ekspandert innhold */}
                  {expanded&&(
                    <div style={{borderTop:`0.5px solid ${C.border}`,padding:"14px 14px"}}>
                      {item.type==="medley"&&item.medley_tracks&&(
                        <div style={{marginBottom:12}}>
                          <div style={{fontSize:11,color:C.muted,textTransform:"uppercase",letterSpacing:0.5,marginBottom:4}}>Låter i medleyen</div>
                          <div style={{fontSize:12,color:C.muted,whiteSpace:"pre-line",lineHeight:1.6}}>{item.medley_tracks}</div>
                        </div>
                      )}
                      {item.notes&&(
                        <div style={{marginBottom:12}}>
                          <div style={{fontSize:11,color:C.muted,textTransform:"uppercase",letterSpacing:0.5,marginBottom:4}}>Notater</div>
                          <div style={{fontSize:13,color:"#ccc",lineHeight:1.5}}>{item.notes}</div>
                        </div>
                      )}
                      {item.costume&&(
                        <div style={{marginBottom:12}}>
                          <div style={{fontSize:11,color:C.muted,textTransform:"uppercase",letterSpacing:0.5,marginBottom:4}}>Kostyme</div>
                          <div style={{fontSize:13,color:"#ccc",lineHeight:1.5}}>{item.costume}</div>
                        </div>
                      )}
                      {item.hair_makeup&&(
                        <div style={{marginBottom:12}}>
                          <div style={{fontSize:11,color:C.muted,textTransform:"uppercase",letterSpacing:0.5,marginBottom:4}}>Hår og sminke</div>
                          <div style={{fontSize:13,color:"#ccc",lineHeight:1.5}}>{item.hair_makeup}</div>
                        </div>
                      )}
                      {item.rep_notes&&(
                        <div style={{marginBottom:12}}>
                          <div style={{fontSize:11,color:C.muted,textTransform:"uppercase",letterSpacing:0.5,marginBottom:4}}>Show-program notater</div>
                          <div style={{fontSize:13,color:"#ccc",lineHeight:1.5}}>{item.rep_notes}</div>
                        </div>
                      )}
                      {hasLinks&&(
                        <div style={{marginBottom:12}}>
                          <div style={{fontSize:11,color:C.muted,textTransform:"uppercase",letterSpacing:0.5,marginBottom:8}}>Filer og lenker</div>
                          <div style={{display:"flex",flexDirection:"column",gap:6}}>
                            {ALL_LINKS.filter(({key})=>item.links[key]).map(({key,label})=>(
                              <div key={key} style={{display:"flex",alignItems:"center",justifyContent:"space-between",padding:"8px 12px",background:C.surface2,borderRadius:8}}>
                                <div style={{fontSize:12,color:C.white,fontWeight:500}}>{label}</div>
                                <div style={{display:"flex",gap:6}}>
                                  <a href={item.links[key]} target="_blank" rel="noreferrer" style={{fontSize:11,padding:"4px 10px",borderRadius:8,background:"none",border:`0.5px solid ${C.border}`,color:C.muted,textDecoration:"none"}}>↗ Åpne</a>
                                  <a href={(()=>{ const m=item.links[key].match(/\/d\/([a-zA-Z0-9_-]+)/u); return m?`https://drive.google.com/uc?export=download&id=${m[1]}`:item.links[key]; })()} target="_blank" rel="noreferrer" style={{fontSize:11,padding:"4px 10px",borderRadius:8,background:"none",border:`0.5px solid ${C.border}`,color:C.muted,textDecoration:"none"}}>⬇ Last ned</a>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      )}
                      <div style={{display:"flex",gap:8,marginTop:4}}>
                        <button style={btn("ghost",{padding:"5px 10px",fontSize:11})} onClick={()=>{setEditing(item);setExpandedId(null);}}>✎ Rediger</button>
                        <button style={btn("danger",{padding:"5px 10px",fontSize:11})} onClick={()=>remove(item.id)}>Slett</button>
                      </div>
                    </div>
                  )}
                </div>
            }
          </div>
        );
      })}
      {medleys.length>0&&<div style={{fontSize:11,color:C.muted,textTransform:"uppercase",letterSpacing:0.8,marginTop:24,marginBottom:8,fontWeight:600}}>Medleys ({medleys.length})</div>}
      {medleys.map(item=>{
        const expanded = expandedId === item.id;
        const hasLinks = item.links && Object.values(item.links).some(v=>v);
        const ALL_LINKS = [
          {key:"instrumental", label:"Instrumental"},
          {key:"klikktrack",   label:"Klikktrack"},
          {key:"choir",        label:"Choir-track"},
          {key:"acapella",     label:"Acapella"},
          {key:"outro",        label:"Outro"},
          {key:"visuals",      label:"Visuals"},
          {key:"tc",           label:"TC fil (lys)"},
          {key:"koreografi",   label:"Koreografi (video)"},
          {key:"showzip",      label:"Show ZIP"},
        ];
        return (
          <div key={item.id} style={{marginBottom:8}}>
            {editing?.id===item.id
              ? <RepertoireForm initial={item} onSave={save} onCancel={()=>setEditing(null)} isMobile={isMobile}/>
              : <div style={card({padding:0,overflow:"hidden"})}>
                  <div onClick={()=>setExpandedId(expanded?null:item.id)} style={{display:"flex",alignItems:"center",gap:12,padding:"12px 14px",cursor:"pointer"}}
                    onMouseEnter={e=>e.currentTarget.style.background=C.surface2}
                    onMouseLeave={e=>e.currentTarget.style.background="transparent"}>
                    <div style={{flex:1,minWidth:0}}>
                      <div style={{display:"flex",alignItems:"center",gap:8,flexWrap:"wrap"}}>
                        <div style={{fontSize:14,fontWeight:500}}>{item.title}</div>
                        {item.duration&&<div style={{fontSize:12,color:C.muted}}>{item.duration}</div>}
                        <span style={{fontSize:11,padding:"2px 8px",borderRadius:20,background:`${C.gold}22`,color:C.gold,border:`0.5px solid ${C.gold}44`}}>Medley</span>
                        {hasLinks&&<span style={{fontSize:11,color:C.muted}}>🔗 {Object.values(item.links).filter(v=>v).length} filer</span>}
                      </div>
                    </div>
                    <div style={{fontSize:10,color:C.muted,transition:"transform 0.2s",transform:expanded?"rotate(180deg)":"rotate(0deg)",flexShrink:0}}>▾</div>
                  </div>
                  {expanded&&(
                    <div style={{borderTop:`0.5px solid ${C.border}`,padding:"14px 14px"}}>
                      {item.medley_tracks&&(
                        <div style={{marginBottom:12}}>
                          <div style={{fontSize:11,color:C.muted,textTransform:"uppercase",letterSpacing:0.5,marginBottom:4}}>Låter i medleyen</div>
                          <div style={{fontSize:12,color:C.muted,whiteSpace:"pre-line",lineHeight:1.6}}>{item.medley_tracks}</div>
                        </div>
                      )}
                      {item.notes&&<div style={{marginBottom:12}}><div style={{fontSize:11,color:C.muted,textTransform:"uppercase",letterSpacing:0.5,marginBottom:4}}>Notater</div><div style={{fontSize:13,color:"#ccc",lineHeight:1.5}}>{item.notes}</div></div>}
                      {item.costume&&<div style={{marginBottom:12}}><div style={{fontSize:11,color:C.muted,textTransform:"uppercase",letterSpacing:0.5,marginBottom:4}}>Kostyme</div><div style={{fontSize:13,color:"#ccc",lineHeight:1.5}}>{item.costume}</div></div>}
                      {item.hair_makeup&&<div style={{marginBottom:12}}><div style={{fontSize:11,color:C.muted,textTransform:"uppercase",letterSpacing:0.5,marginBottom:4}}>Hår og sminke</div><div style={{fontSize:13,color:"#ccc",lineHeight:1.5}}>{item.hair_makeup}</div></div>}
                      {item.rep_notes&&<div style={{marginBottom:12}}><div style={{fontSize:11,color:C.muted,textTransform:"uppercase",letterSpacing:0.5,marginBottom:4}}>Show-program notater</div><div style={{fontSize:13,color:"#ccc",lineHeight:1.5}}>{item.rep_notes}</div></div>}
                      {hasLinks&&(
                        <div style={{marginBottom:12}}>
                          <div style={{fontSize:11,color:C.muted,textTransform:"uppercase",letterSpacing:0.5,marginBottom:8}}>Filer og lenker</div>
                          <div style={{display:"flex",flexDirection:"column",gap:4}}>
                            {ALL_LINKS.filter(({key})=>item.links[key]).map(({key,label})=>(
                              <div key={key} style={{display:"flex",alignItems:"center",justifyContent:"space-between",padding:"7px 12px",background:C.surface2,borderRadius:8}}>
                                <div style={{fontSize:12,color:C.white,fontWeight:500}}>{label}</div>
                                <div style={{display:"flex",gap:6}}>
                                  <a href={item.links[key]} target="_blank" rel="noreferrer" style={{fontSize:11,padding:"4px 10px",borderRadius:8,background:"none",border:`0.5px solid ${C.border}`,color:C.muted,textDecoration:"none"}}>↗ Åpne</a>
                                  <a href={(()=>{ const m=item.links[key].match(/\/d\/([a-zA-Z0-9_-]+)/u); return m?`https://drive.google.com/uc?export=download&id=${m[1]}`:item.links[key]; })()} target="_blank" rel="noreferrer" style={{fontSize:11,padding:"4px 10px",borderRadius:8,background:"none",border:`0.5px solid ${C.border}`,color:C.muted,textDecoration:"none"}}>⬇ Last ned</a>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      )}
                      <div style={{display:"flex",gap:8,marginTop:4}}>
                        <button style={btn("ghost",{padding:"5px 10px",fontSize:11})} onClick={()=>{setEditing(item);setExpandedId(null);}}>✎ Rediger</button>
                        <button style={btn("danger",{padding:"5px 10px",fontSize:11})} onClick={()=>remove(item.id)}>Slett</button>
                      </div>
                    </div>
                  )}
                </div>
            }
          </div>
        );
      })}
    </div>
  );
}